import { Card, Col, Layout, Row } from "antd";
import { Content } from "antd/es/layout/layout";
import CONSTANTS from "constants/constants";
import aboutUs from "assets/about_us.svg";
import aboutCompany from "assets/about_company.svg";
import ourTeam1 from "assets/natraj_profile_close.jpg";
import "./style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faRocket, faTrophy } from "@fortawesome/free-solid-svg-icons";

const AboutUs = () => {
  const { ABOUT_US } = CONSTANTS;

  return (
    <Layout>
      <Content>
        <Row
          className="about-us-section pr4 pl4 pb2 pt2 about-us-main"
          justify="space-around"
          align="middle"
          gutter={[0, 16]}
        >
          <Col lg={12}>
            <p className="about-us-section-header mt1">
              About <span className="about-us-special-text">us</span>
            </p>
            <p className="about-us-section-text">
              {ABOUT_US.ABOUT_US_1}
              <span className="about-us-special-text">
                {ABOUT_US.ABOUT_US_2}
              </span>
              {ABOUT_US.ABOUT_US_3}
            </p>
          </Col>
          <Col lg={12} className="flex-center">
            <img src={aboutUs} className="about-us-image" alt="about us" />
          </Col>
        </Row>

        <Row
          className="pr4 pl4 pb2 pt2 about-us-main"
          justify="space-around"
          align="middle"
          gutter={[0, 16]}
        >
          <Col lg={{ span: 12, order: 2 }} md={{ order: 1 }}>
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <p className="about-us-section-header mt1">
                  <span className="about-us-special-text">About</span> our
                  company
                </p>
                <p className="about-us-section-text">
                  <span className="about-us-special-text">
                    {ABOUT_US.ABOUT_COMPANY1}
                  </span>
                  {ABOUT_US.ABOUT_COMPANY2}
                </p>
              </Col>
              <Col span={24}>
                <p className="about-us-section-header mt1">
                  <span className="about-us-special-text">Ṛtam</span> - the name
                </p>
                <p className="about-us-section-text">
                  <span className="about-us-special-text">
                    {ABOUT_US.ABOUT_RTAM1}
                  </span>
                  {ABOUT_US.ABOUT_RTAM2}
                </p>
                <p className="about-us-section-text">{ABOUT_US.ABOUT_RTAM3}</p>
              </Col>
            </Row>
          </Col>
          <Col
            lg={{ span: 12, order: 1 }}
            md={{ order: 2 }}
            className="flex-center"
          >
            <img
              src={aboutCompany}
              className="about-us-image"
              alt="about company"
            />
          </Col>
        </Row>

        <Row className="about-us-section about-us-main p4">
          <Col lg={24}>
            <Row justify="space-around">
              <p className="about-us-section-header mt1">
                Our <span className="about-us-special-text">culture</span>
              </p>
            </Row>
            <Row justify="space-around">
              <p className="about-us-section-text">{ABOUT_US.OUR_CULTURE}</p>
            </Row>
            <Row justify="center" gutter={[{ md: 16, lg: 32, xl: 48 }, 16]}>
              <Col xl={6} lg={7} md={8} sm={24}>
                <Card bordered={true} className="h100">
                  <p className="about-culture-card-head mt0 mb0">
                    <span className="about-us-special-text mr1">
                      <FontAwesomeIcon icon={faEye} />
                    </span>
                    Vision
                  </p>
                  <p className="about-culture-card-text">{ABOUT_US.VISION}</p>
                </Card>
              </Col>
              <Col xl={6} lg={7} md={8} sm={24}>
                <Card bordered={true} className="h100">
                  <p className="about-culture-card-head mt0 mb0">
                    <span className="about-us-special-text mr1">
                      <FontAwesomeIcon icon={faRocket} />
                    </span>
                    Mission
                  </p>
                  <p className="about-culture-card-text">{ABOUT_US.MISSION}</p>
                </Card>
              </Col>
              <Col xl={6} lg={7} md={8} sm={24}>
                <Card bordered={true} className="h100">
                  <p className="about-culture-card-head mt0 mb0">
                    <span className="about-us-special-text mr1">
                      <FontAwesomeIcon icon={faTrophy} />
                    </span>
                    Motto
                  </p>
                  <p className="about-culture-card-text">{ABOUT_US.MOTTO}</p>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="about-our-team-section">
          <Col lg={24} className="about-us-our-team">
            <Row className="mb2">
              <p className="about-us-section-header about-us-team">
                Our <span className="about-us-special-text">Team</span>
              </p>
            </Row>
            <Row
              align="middle"
              justify="space-around"
              className="about-us-section about-our-team"
              gutter={[0, 32]}
            >
              <Col lg={8} className="flex-center">
                <img
                  src={ourTeam1}
                  alt="our team 1"
                  className="about-team-image"
                />
              </Col>
              <Col lg={16} className="p1">
                <p className="about-team-header">{ABOUT_US.OUR_TEAM_NAME1}</p>
                <p className="about-team-sub-header">
                  {ABOUT_US.OUR_TEAM_POSITION1}
                </p>
                <p className="about-us-section-text">
                  {ABOUT_US.OUR_TEAM_DETAIL1}
                </p>
              </Col>
            </Row>
            {/* <Row
              align="middle"
              justify="space-around"
              className="about-us-section about-our-team"
              gutter={[0, 32]}
            >
              <Col lg={8} className="flex-center">
                <img
                  src={ourTeam1}
                  alt="our team 1"
                  className="about-team-image"
                />
              </Col>
              <Col lg={16} className="p1">
                <p className="about-team-header">{ABOUT_US.OUR_TEAM_NAME2}</p>
                <p className="about-team-sub-header">
                  {ABOUT_US.OUR_TEAM_POSITION2}
                </p>
                <p className="about-us-section-text">
                  {ABOUT_US.OUR_TEAM_DETAIL2}
                </p>
              </Col>
            </Row> */}
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default AboutUs;
